module.exports = __webpack_public_path__ + "img/janvideoflow-button.538968e9.png";